<template>
    <div class="position-relative">
       <!-- Begin Page Content -->
        <div class="Analyze-section">
            <div class="row mb-4 ">
                <div class="col-md-3 col-12">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-0">
                            <h3 class="General">General Clinical Research</h3>
                            <ul class="research-area mb-0" role="tablist">
                                <li class="d-flex justify-content-between border-top"><router-link to="/analyze-report" class="nav-lank">Complete Blood Count</router-link></li>
                                <li class="d-flex justify-content-between border-top"><router-link to="/pre-diabetes" class="nav-lank">Pre-Diabetes or Metabolic Syndrome</router-link></li>
                                <li class="d-flex justify-content-between border-top border-bottom"><router-link to="/serum-electrolytes" class="nav-lank active">Serum Electrolytes</router-link></li>
                            </ul>
                            <div class="Serum-Electrolytes text-center mt-4">
                                <h4>Biomarkers History</h4>
                                <figure class="overall-health">
                                    <router-link to="/overall-health"><img src="../../../../static/website/images/overall-health.png" alt="" /></router-link>
                                </figure>
                                <h6 class="last-week">+ 0.3 since last week</h6>
                                <ul class="Serum mb-3 mt-3">
                                    <li class="d-flex justify-content-between">
                                        <p>Patient</p>
                                        <p>Male, 46 years</p>
                                    </li>
                                    <li class="d-flex justify-content-between">
                                        <p>Last Tested Date</p>
                                        <p>07.02.2020</p>
                                    </li>
                                </ul>
                                <div class="button-Download d-flex justify-content-between">
                                    <a href="#" class="btn Download mr-1"><i class="icon icon-download"></i> Download</a>
                                    <a href="#" class="btn Download ml-1"><i class="icon icon-mail"></i> Email</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-12">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-bodytext-center text-center">
                            <div class="card-top d-flex justify-content-between align-items-center p-3">
                                <form class="form-search position-relative single-post-search">
                                    <button class="btn button search"><i class="icon icon-search"></i></button>
                                    <input type="text" name="text" placeholder="Search Biomarkers" />
                                </form>
                                <ul class="mb-0 d-flex add-bookmark">
                                    <li class="dropdown">
                                        <a href="#" class="btn btn-default dropdown-toggle" id="dropdown01" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="icon icon-plus mr-2 justify-content-center align-items-center"></i> Add Biomarkers
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="dropdown01">
                                            <h2>Biomarkers</h2>
                                            <form class="form-search position-relative single-post-search">
                                                <input type="text" name="text" placeholder="Write biomarker name..." />
                                            </form>
                                            <h3>Top Matches</h3>
                                            <a href="#">Hemoglobin A0</a>
                                            <a href="#">Hemoglobin A1c</a>
                                            <a href="#">Hemoglobin A2</a>
                                            <a href="#">Hemoglobin C</a>
                                            <a href="#">Hemoglobin D</a>
                                            <a href="#">Hemoglobin distribution width</a>
                                        </div>
                                    </li>
                                    <li class="dropdown">
                                        <a href="#" class="btn btn-gray d-flex justify-content-center align-items-center dropdown-toggle" id="dropdown02" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="icon icon-filter"></i>
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="dropdown02">
                                            <h2>Filter</h2>
                                            <a href="#" class="justify-content-start d-flex align-items-center"><span class="green"></span> With in range</a>
                                            <a href="#" class="justify-content-start d-flex align-items-center"><span class="yellow"></span> Improving</a>
                                            <a href="#" class="justify-content-start d-flex align-items-center"><span class="red"></span> Out of Range</a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="table-responsive">
                                <table class="table name-test mt-2" border="0" cellspacing="0" cellpadding="0">
                                    <thead>
                                        <tr>
                                            <th>Name of Test</th>
                                            <th>Lab Range</th>
                                            <th>Your Levels</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="d-flex justify-content-start align-items-start"><span class="green"></span> Sodium</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                        <tr>
                                            <td class="d-flex justify-content-start align-items-start"><span class="green"></span> Potassium</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                        <tr>
                                            <td class="d-flex justify-content-start align-items-start"><span class="yellow"></span> Calcium</td>
                                            <td>.name-test tr td</td>
                                            <td class="yellow">10.04 mg/dl</td>
                                        </tr>
                                        <tr>
                                            <td class="d-flex justify-content-start align-items-start"><span class="green"></span> Magnesium</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                        <tr>
                                            <td class="d-flex justify-content-start align-items-start"><span class="red"></span> Chloride</td>
                                            <td>-</td>
                                            <td class="red">-</td>
                                        </tr>
                                        <tr>
                                            <td class="d-flex justify-content-start align-items-start"><span class="green"></span> Phosphate</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                        <tr>
                                            <td class="d-flex justify-content-start align-items-start"><span class="green"></span> Ionic Calcium</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-0">
                            <div class="text-center w-100 p-3">
                                <h3 class="mb-3">Calcium</h3>
                                <p>
                                    Calcium is a mineral that is necessary for life. In addition to building bones and keeping them healthy, calcium enables our blood to clot, our muscles to contract, and our heart to beat. About
                                    99% of the calcium in our bodies is in our bones and teeth.
                                </p>
                            </div>
                            <ul class="Serum mb-0 px-3">
                                <li class="d-flex justify-content-between">
                                    <p class="range">Lab Range</p>
                                    <p class="range gray">8.8-10.6 mg/dl</p>
                                </li>
                                <li class="d-flex justify-content-between">
                                    <p class="range">Your Levels</p>
                                    <p class="yello range">10.04 mg/dl</p>
                                </li>
                            </ul>
                            <figure class="mt-3 mb-0 chart-ana"><img src="../../../../static/website/images/chart-ana.png" alt="" /></figure>
                            <h4 class="px-3 mt-4">History</h4>
                            <ul class="mb-0 History">
                                <li class="d-flex justify-content-between border-top">
                                    <p class="mb-0">17 May 2021</p>
                                    <p class="mb-0 yellow d-flex justify-content-center align-items-center">10.04 mg/dl <span class="yellow"></span></p>
                                </li>
                                <li class="d-flex justify-content-between border-top">
                                    <p class="mb-0">20 April 2021</p>
                                    <p class="mb-0 green d-flex justify-content-center align-items-center">10.04 mg/dl <span class="normal"></span></p>
                                </li>
                                <li class="d-flex justify-content-between border-top">
                                    <p class="mb-0">07 Mar 2021</p>
                                    <p class="mb-0 green d-flex justify-content-center align-items-center">33.5 g/dL <span class="normal"></span></p>
                                </li>
                                <li class="d-flex justify-content-between border-top">
                                    <p class="mb-0">02 Feb 2021</p>
                                    <p class="mb-0 red d-flex justify-content-center align-items-center">7.5 g/dL <span class="low"></span></p>
                                </li>
                                <li class="d-flex justify-content-between border-top">
                                    <p class="mb-0">15 Feb 2021</p>
                                    <p class="mb-0 red d-flex justify-content-center align-items-center">6.2 g/dL <span class="low"></span></p>
                                </li>
                                <li class="d-flex justify-content-between border-top border-bottom">
                                    <p class="mb-0">15 Dec 2020</p>
                                    <p class="mb-0 green d-flex justify-content-center align-items-center">9.5 g/dL <span class="normal"></span></p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="Biomarkers bg-white border-radius-5 p-4 mb-5" style="display: none;">
            <div class="d-flex justify-content-between align-items-center">
                <h2>Biomarkers</h2>
                <form class="radio-box question-radio">
                    <div class="form-group m-0">
                        <input type="checkbox" id="terrible" />
                        <label class="mb-0" for="terrible">Terrible</label>
                    </div>
                </form>
            </div>
            <div class="form-group">
                <input type="text" name="" placeholder="Hemoglobin A0" />
            </div>
            <div class="d-flex justify-content-between align-items-center mb-5">
                <div class="form-group helf-group">
                    <input type="text" name="" placeholder="Value..." />
                </div>
                <div class="form-group helf-group">
                    <input type="text" name="" placeholder="L/L" />
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "Serum-Electrolytes",
        data() {
            return {};
        },
        created(){
           this.pageName('Analyze Your Report')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/test_report/serum-electrolytes.vue